import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccountGroup, AccountGroupService, ProjectionFilter, ReadFilter } from '@galaxy/account-group';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BusinessInfoCellService {
  accountGroupMapping = new Map<string, Observable<AccountGroup>>();

  constructor(
    private accountGroupService: AccountGroupService,
    private translateService: TranslateService,
  ) {}

  // attempts to get the account group from the service's existing mapping otherwise makes the http request
  getAccountGroup(accountGroupId: string): Observable<AccountGroup> {
    if (this.accountGroupMapping.get(accountGroupId)) {
      return this.accountGroupMapping.get(accountGroupId);
    }
    return this.accountGroupService
      .getMulti([accountGroupId], new ProjectionFilter({ napData: true }), new ReadFilter({ includeDeleted: true }))
      .pipe(
        switchMap((accountGroups) => {
          if (accountGroups?.length === 1 && !!accountGroups[0]) {
            this.accountGroupMapping.set(accountGroups[0].accountGroupId, of(accountGroups[0]));
            return of(accountGroups[0]);
          }
          throwError(this.translateService.instant('AUTOMATIONS.ERRORS.ACCOUNT_NOT_FOUND'));
          return EMPTY;
        }),
        shareReplay(1),
      );
  }
}
